import { render, staticRenderFns } from "./SearchBanner.vue?vue&type=template&id=49af4641"
import script from "./SearchBanner.vue?vue&type=script&lang=js"
export * from "./SearchBanner.vue?vue&type=script&lang=js"
import style0 from "./SearchBanner.vue?vue&type=style&index=0&id=49af4641&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports